import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Radio } from 'lucide-react';

const DemoProjects = () => {
  return (
    <div className="min-h-screen bg-[#F8FAF9] pt-32 pb-20 px-4 sm:px-6 lg:px-12">
      <div className="max-w-6xl mx-auto space-y-10">
        <div className="space-y-4">
          <h1 className="font-serif text-4xl lg:text-5xl text-[#11201E] tracking-tight">Project Demos</h1>
          <p className="text-base text-[#3D5551] max-w-3xl leading-relaxed">
            Explore interactive implementations from my applied AI systems work.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Link
            to="/demos/live-voice-transcription-insight-engine"
            className="group block rounded-2xl border border-teal-100 bg-white p-6 shadow-sm hover:shadow-xl hover:border-teal-300 transition-all duration-300"
          >
            <article className="space-y-4">
              <div className="inline-flex items-center gap-2 px-3 py-1 text-xs font-semibold tracking-wide rounded-full bg-teal-100 text-teal-700">
                <Radio size={14} />
                Live Streaming Demo
              </div>
              <h2 className="font-serif text-2xl text-[#11201E] group-hover:text-teal-700 transition-colors">
                Live Voice Transcription & Insight Engine
              </h2>
              <p className="text-sm text-[#4A6660] leading-relaxed">
                End-to-end real-time transcription demo with microphone and audio-file streaming over canonical PCM16 frames.
              </p>
              <div className="inline-flex items-center gap-2 text-sm font-semibold text-teal-700 group-hover:gap-3 transition-all">
                Open demo <ArrowRight size={14} />
              </div>
            </article>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DemoProjects;
